import camelCase from 'lodash/camelCase';
import { FeatureItem } from './FeatureItem';
import { BoolFeature } from '../BoolFeature';
import { NameFeature } from '../NameFeature';
import { NamesFeature } from '../NamesFeature';
import { StarsFeature } from '../StarsFeature';
import { SimpleFeature } from '../SimpleFeature';
import React from 'react';
import * as PropTypes from 'prop-types';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Unstable_Grid2';


const FeatureDialogIcon = React.lazy(() => import('./featureDialogIcon'));

export const FeatureItemRow = ({ item, trimLevel, jargon }) => {

  const slug = camelCase(item.slug);

  if (!item.details_show) {
    return null;
  }
  const v = trimLevel[slug];
  if (v === null || typeof v === 'undefined' || (Array.isArray(v) && !v.length)) {
    return null;
  }

  const simpleTypes = ['int', 'float', 'string', 'term'];

  return (
    <Grid xs={12} md={6} lg={4}>
      <FeatureItem sx={{ ml: 1, mr: 1 }}>
        <Stack xs={8} sx={{ justifyContent: 'space-between', alignItems: 'center', p: 0, pt: 1, pb: 0 }}
          direction={'row'}>
          <Box>
            <React.Suspense fallback={<span>{item.name}</span>}>
              <FeatureDialogIcon jargon={jargon} slug={slug}>{item.name}</FeatureDialogIcon>
            </React.Suspense>
          </Box>
          <Box xs={4} sx={{ p: 0, display: 'flex' }}>
            {item.type === 'bool' && (<BoolFeature jargon={jargon} slug={slug} trimLevel={trimLevel} />)}
            {item.type === 'name' && (<NameFeature {...item} slug={slug} trimLevel={trimLevel} />)}
            {item.type === 'names' && (<NamesFeature {...item} slug={slug} trimLevel={trimLevel} />)}
            {item.type === 'stars' && (<StarsFeature {...item} slug={slug} trimLevel={trimLevel} />)}
            {simpleTypes.indexOf(item.type) !== -1 &&
              <SimpleFeature fieldType={item.type} slug={slug} trimLevel={trimLevel} />}
          </Box>
        </Stack>
      </FeatureItem>
    </Grid>);
};

FeatureItemRow.propTypes = {
  trimLevel: PropTypes.shape({}), item:
    PropTypes.shape({
      'category': PropTypes.node,
      'details_show': PropTypes.bool,
      'name': PropTypes.node.isRequired,
      'path': PropTypes.string,
      'search_show': PropTypes.bool,
      'slug': PropTypes.string.isRequired,
      'type': PropTypes.string.isRequired
    }), jargon:
    PropTypes.shape({})
};